import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Sidebar from "./Sidebar";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import ADMIN_PATHS from "../ADMIN_PATHS";
import AdminHeader from './AdminHeader';
import { fetchAdminProfile } from "../../../features/adminAuthSlice";

const AdminLayout = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { user, token } = useSelector((state) => state.adminAuth);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  useEffect(() => {
    setMobileSidebarOpen(false);
  }, [location.pathname, location.search, location.hash]);

  useEffect(() => {
    if (!mobileSidebarOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [mobileSidebarOpen]);

  useEffect(() => {
    if (!token || !user) return;
    if (!user.profilePic) {
      dispatch(fetchAdminProfile());
    }
  }, [dispatch, token, user]);

  // Hard guard: never render admin UI/routes without a valid session.
  if (!token || !user) {
    return (
      <Navigate
        to={ADMIN_PATHS.AUTH.LOGIN}
        replace
        state={{ from: location.pathname + location.search + location.hash }}
      />
    );
  }

  return (
    <div className="admin-shell flex min-h-screen w-full bg-white">
      {/* Sidebar (hidden on mobile) */}
      <Sidebar
        mobileOpen={mobileSidebarOpen}
        onClose={() => setMobileSidebarOpen(false)}
      />
      {/* Main content */}
      <div className="admin-main flex-1 flex min-h-screen min-w-0 flex-col lg:ml-[292px]">
        <AdminHeader
          title="Manage admin"
          onOpenSidebar={() => setMobileSidebarOpen(true)}
        />
        <main className="admin-page-content flex-1 min-w-0 bg-white p-4 md:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
